import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  ShoppingBag,
  User,
  LogOut,
  Menu,
  X,
  Plus,
  Minus,
  Trash2,
} from "lucide-react";
import { useAuth } from "../../context/userContext";
import "../../styles/WebLayout.scss";
import { logo, logoMob } from "../../assests/imageModule/image";
import { useCart } from "../../context/CartContext";
import userServiceInstance from "../../services/userService";
import Checkout from "../../pages/Checkout";
import Login from "../../pages/Login";
import CheckoutModal from "../CheckoutModal";

const Header = () => {
  const { auth, logout } = useAuth();
  const { cartList, removeFromCart, updateQuantity, setCartShow, cartShow } =
    useCart();

  const [isFixed, setIsFixed] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const [promotionContent, setPromotionContent] = useState(null);

  const navRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Fixed: should be useEffect, not useState
  useEffect(() => {
    const fetchSubHeader = async () => {
      try {
        const res = await userServiceInstance.getSubHeaderTagline();
        if (res?.data?.success) {
          setPromotionContent(res?.data?.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchSubHeader();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showLogin && !event.target.closest(".drop_down")) {
        setShowLogin(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogin]);

  const handleGoToCart = () => {
    setCartShow(true);
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
  }, [cartList]);

  useEffect(() => {
    setShowMobileMenu(false);
  }, [location]);

  const isPathActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  const getCartTotal = () => {
    return cartList.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
  };

  const getTotalItems = () => {
    return cartList.reduce((total, item) => total + item.quantity, 0);
  };

  const [checkoutModal, setCheckoutModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);

  const handleGoToCheckout = () => {
    setCartShow(false);
    setCheckoutModal(true);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const checkout = params.get("checkout");
    if (checkout === "true") {
      setCheckoutModal(true);
    }
  }, []);

  return (
    <section className="navbar_layout">
      <div className="header_wrapper">
        {promotionContent?.text && (
          <div className="t_head">
            <div className="container">
              <marquee>{promotionContent?.text}</marquee>
            </div>
          </div>
        )}

        <div className={`m_head ${isFixed ? "fixed" : ""}`} ref={navRef}>
          <div className="container">
            <div className="header">
              <div className="logo" onClick={() => navigate("/")}>
                <img className="desk" src={logo} alt="logo" width="120" />
                <img className="mob" src={logoMob} alt="logo" width="120" />
              </div>

              <div className="sidebar_link desk">
                <div className="container">
                  <div className="header_links">
                    <ul>
                      <li>
                        <Link
                          to="/"
                          className={
                            isPathActive("/") ? "txt_link active" : "txt_link"
                          }
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/a2-bilona-cow-ghee"
                          className={
                            isPathActive("/a2-bilona-cow-ghee")
                              ? "txt_link active"
                              : "txt_link"
                          }
                        >
                          A2 Cow Ghee
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/a2-bilona-buffalo-ghee"
                          className={
                            isPathActive("/a2-bilona-buffalo-ghee")
                              ? "txt_link active"
                              : "txt_link"
                          }
                        >
                          A2 Buffalo Ghee
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/organic-honey"
                          className={
                            isPathActive("/organic-honey")
                              ? "txt_link active"
                              : "txt_link"
                          }
                        >
                          Organic Honey
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/blogs"
                          className={
                            isPathActive("/blogs")
                              ? "txt_link active"
                              : "txt_link"
                          }
                        >
                          Blogs
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="login_links">
                <ul>
                  <li>
                    <p onClick={handleGoToCart} className="cart-trigger">
                      <ShoppingBag size={16} />
                    </p>
                    {cartList?.length > 0 && (
                      <span className="cart-count">{getTotalItems()}</span>
                    )}
                  </li>

                  <li>
                    {!auth?.user?._id ? (
                      <div className="drop_down">
                        <p onClick={() => setLoginModal(!loginModal)}>
                          <User size={16} />
                        </p>
                      </div>
                    ) : (
                      <div
                        className="drop_down"
                        onClick={() => setShowLogin(!showLogin)}
                      >
                        <p>
                          <User size={16} />
                        </p>

                        {showLogin && (
                          <div className="google_login">
                            <div className="user_info">
                              <h4>{auth?.user?.name || "Saaj User"}</h4>
                            </div>

                            <div className="action_buttons">
                              <Link
                                to="/account/profile?active=userdetail"
                                className="profile_btn"
                              >
                                Profile
                              </Link>
                              <Link
                                to="/account/profile?active=changePassword"
                                className="password_btn"
                              >
                                Change Password
                              </Link>
                              <Link
                                to="/account/profile?active=orders"
                                className="orders"
                              >
                                Order History
                              </Link>
                              {auth?.user?.role === 12 && (
                                <Link
                                  to="/account/dashboard"
                                  className="profile_btn"
                                >
                                  Dashboard
                                </Link>
                              )}
                              <button onClick={logout} className="logout_btn">
                                <LogOut size={16} /> Logout
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </li>

                  <li className="mobile-menu-toggle">
                    <button onClick={() => setShowMobileMenu(!showMobileMenu)}>
                      {showMobileMenu ? <X size={16} /> : <Menu size={16} />}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`mobile-sidebar ${showMobileMenu ? "open" : ""}`}>
        <div className="mobile-sidebar-content">
          <div className="mobile-nav-links">
            <Link
              to="/"
              className={`mobile-nav-item ${isPathActive("/") ? "active" : ""}`}
            >
              <img className="mob" src={logoMob} alt="logo" />
            </Link>
            <Link
              to="/a2-bilona-cow-ghee"
              className={`mobile-nav-item ${
                isPathActive("/a2-bilona-cow-ghee") ? "active" : ""
              }`}
            >
              <span>A2 Cow Ghee</span>
            </Link>
            <Link
              to="/a2-bilona-buffalo-ghee"
              className={`mobile-nav-item ${
                isPathActive("/a2-bilona-buffalo-ghee") ? "active" : ""
              }`}
            >
              <span>A2 Buffalo Ghee</span>
            </Link>
            <Link
              to="/organic-honey"
              className={`mobile-nav-item ${
                isPathActive("/organic-honey") ? "active" : ""
              }`}
            >
              <span>Organic Honey</span>
            </Link>
            <Link
              to="/blogs"
              className={`mobile-nav-item ${
                isPathActive("/blogs") ? "active" : ""
              }`}
            >
              <span>Blogs</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Cart Sidebar */}
      <div className={`cart-sidebar ${cartShow ? "open" : ""}`}>
        <div
          className="cart-sidebar-overlay"
          onClick={() => setCartShow(false)}
        ></div>
        <div className="cart-sidebar-content">
          <div className="cart-header">
            <h2>Shopping Cart</h2>
            <button
              className="close-cart"
              onClick={() => setCartShow(false)}
              aria-label="Close cart"
            >
              <X size={16} />
            </button>
          </div>

          <div className="cart-body">
            {cartList.length === 0 ? (
              <div className="empty-cart">
                <ShoppingBag className="empty-cart-icon" size={16} />
                <p>Your cart is empty</p>
                <button
                  className="continue-shopping"
                  onClick={() => setCartShow(false)}
                >
                  Continue Shopping
                </button>
              </div>
            ) : (
              <>
                <div className="cart-items">
                  {cartList.map((item) => (
                    <div
                      key={`${item.productId}-${item.size}`}
                      className="cart-item"
                    >
                      <div className="item-image">
                        <img
                          src={`${process.env.REACT_APP_FILE_PATH}/${item.image}`}
                          alt={`${item.name} -${item.name}`}
                        />
                      </div>

                      <div className="item-details">
                        <h4 className="item-name">{item.name}</h4>
                        <p className="item-price">
                          ₹{item.price} <span>( {item?.size} )</span>
                        </p>

                        <div className="quantity-controls">
                          <button
                            className="quantity-btn"
                            onClick={() =>
                              updateQuantity(
                                item.productId,
                                item.size,
                                item.quantity - 1
                              )
                            }
                          >
                            <Minus size={16} />
                          </button>
                          <span className="quantity">{item.quantity}</span>
                          <button
                            className="quantity-btn"
                            onClick={() =>
                              updateQuantity(
                                item.productId,
                                item.size,
                                item.quantity + 1
                              )
                            }
                            disabled={item.quantity >= item.stockQuantity}
                          >
                            <Plus size={16} />
                          </button>
                        </div>
                      </div>

                      <div className="item-actions">
                        <p className="item-total">
                          ₹{item.price * item.quantity}
                        </p>
                        <button
                          className="remove-item"
                          onClick={() =>
                            removeFromCart(item.productId, item.size)
                          }
                          aria-label="Remove item"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="cart-summary">
                  <div className="summary-row">
                    <span>Subtotal ({getTotalItems()} items)</span>
                    <span className="summary-price">₹{getCartTotal()}</span>
                  </div>
                  <div className="summary-row">
                    <span>Shipping</span>
                    <span className="summary-price">
                      {getCartTotal() >= 999 ? "Free" : "₹149"}
                    </span>
                  </div>
                  <div className="summary-row total">
                    <span>Total</span>
                    <span className="summary-price">
                      ₹
                      {getCartTotal() >= 999
                        ? getCartTotal()
                        : getCartTotal() + 149}
                    </span>
                  </div>
                  {getCartTotal() < 999 && (
                    <p className="free-shipping-notice">
                      Add products worth ₹{999 - getCartTotal()} more for free
                      delivery!
                    </p>
                  )}
                </div>

                <div className="cart-actions">
                  <button
                    className="checkout-btn"
                    onClick={() => handleGoToCheckout()}
                  >
                    Checkout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {checkoutModal && (
        <CheckoutModal
          show={checkoutModal}
          setShow={setCheckoutModal}
          padding="0"
          width="100%"
          maxWidth={!auth?.user?._id && window?.innerWidth > 992 ? "70%" : ""}
          className="modal_scroll"
        >
          <Checkout />
        </CheckoutModal>
      )}

      <Login show={loginModal} setShow={setLoginModal} />
    </section>
  );
};
export default Header;
